import Vue from 'vue'
import Vuex from 'vuex'
import {getPageSetInfo, isHD} from "@/assets/util";

Vue.use(Vuex)
let info = getPageSetInfo();

const state = {
	loginInfo: {
		user: {}
	},
	shopId: '',
	merchantId: '',
  salesManagement: info.salesManagement,
  retailManagement: info.retailManagement,
  promotionManagement: info.promotionManagement,
  moduleOptometry:info.moduleOptometry,
	isLogin: false,
	loginOut: false,
	loginExpired: true,
	indexPageLeft: 0,
  dailyReminder: true,//每日提醒
  paramInfo: {},// 设置暂存信息
  pendingId: 0,// 挂单的id
	pendingOrder: [],// 挂单的数据
	currMember: {},//当前销售的会员
  indexBox: 1,
  printDownload:'',// 打印控件下载地址 改在 utils.js 的 printDownload()
  leftWidth: info.salesGoodsWidth || 0, //记录左侧宽度
  model:[{prop: 'name', fontSize: 14, width: '', label: '商品名称', show: true, char: 14, align: 'left',value:'商品名称'}
  , {
    prop: 'colorName',
    fontSize: 14,
    width: '',
    label: '颜色',
    show: true,
    char: 8,
    align: 'center',value:'颜色'
  }
  , {
    prop: 'diopterName',
    fontSize: 14,
    width: '',
    label: '尺码' ,
    show: true,
    char: 8,
    align: 'center',value:'尺码'
  }], // 存放设置值
  LeftsalesGoods : info.salesGoods, // 存放显示与隐藏右侧
  enterInfo:'', // 存放结账状态
}

// 修改状态，并且是同步的。在组件中使用$store.commit('', params)。类似于组件中的自定义事件
const mutations = {
	setLoginInfo (state, lang) {
		state.loginInfo = lang;
    // console.log(state.loginInfo);
	},
  setSalesManagement(state, lang) {
    state.salesManagement = lang;
  },
  setRetailManagement(state, lang) {
    state.retailManagement = lang;
  },
  setPromotionManagement(state, lang) {
    state.promotionManagement = lang;
  },
  setModuleOptometry(state, lang) {
    state.moduleOptometry = lang;
  },
	setCurrMember (state, lang) {
		state.currMember = lang;
  },
  //存入左侧宽度
  setLeftWidth(state,lang){
    state.leftWidth = lang;
  },
  // 存放设置值
  setModel(state,lang) {
    state.model = lang;
  },
  // 存放显示与隐藏右侧
  setLeftsalesGoods(state,lang) {
    state.LeftsalesGoods = lang;
  },
  setEnterInfo(state,lang) {
    state.enterInfo = lang;
  },
  setPendingOrder(context, param) {
    state.pendingOrder = lang;
  },
}

// 异步操作。在组件中使用是$store.dispath('')
const actions = {
	setLoginInfo (context, param) {
		context.commit('setLoginInfo', param);
	},
  setModuleOptometry (context, param) {
    context.commit('setModuleOptometry', param);
  },
  setSalesManagement (context, param) {
    context.commit('setSalesManagement', param);
  },
  setPromotionManagement (context, param) {
    context.commit('setPromotionManagement', param);
  },
  setCurrMember (context, param) {
		context.commit('setCurrMember', param);
  },
  setLeftWidth(context, param) {
    context.commit('setLeftWidth', param);
  },
  setModel(context, param) {
    context.commit('setModel', param);
  },
  setLeftsalesGoods(context, param) {
    context.commit('setLeftsalesGoods', param);
  },
  setPendingOrder(context, param) {
    context.commit('setPendingOrder', param);
  },
}

// 对数据获取之前的再次编译，可以理解为state的计算属性。在组件中使用 $sotre.getters.fn()
const getters = {
	getLoginInfo (state) {
		return state.loginInfo;
	},
  getSalesManagement (state) {
    return state.salesManagement;
  },
  getRetailManagement (state) {
    return state.retailManagement;
  },
  getPromotionManagement (state) {
    return state.promotionManagement;
  },
  getModuleOptometry (state) {
    return state.moduleOptometry;
  },
	getCurrMember (state) {
		return state.currMember;
  },
    //存入左侧宽度
  getLeftWidth(state){
    return state.leftWidth;
  },
  // 存放设置值
  getModel(state) {
    return state.model;
  },
   // 存放显示与隐藏右侧
   getLeftsalesGoods(state) {
    return state.LeftsalesGoods;
  },
  getEnterInfo(state) {
    return state.enterInfo;
  },

  // 挂单的数据
  getPendingOrder(state) {
    return state.pendingOrder;
  },
}

export default new Vuex.Store({
	state,
	mutations,
	actions,
	getters
})



// WEBPACK FOOTER //
// ./src/vuex/store.js